/* Download a File with Vue and Axios
 * 參考:https://www.larry.dev/download-a-file-with-vue-and-axios/
 */
import { ElMessage } from 'element-plus'
import axios from "axios";

export const useDownload = (url, fileName) => {
    //url:含參數(ex./api/downlad?id=1)
    //fileName:下載後顯示的檔案名稱
    //用axios封裝方法(axiox.get)無法覆蓋responseType為blob，會有中文亂碼問題
    if (process.env.NODE_ENV == "production") url = "/METE_OUTLET" + url;
    axios({
        url: url,
        method: 'get',
        responseType: 'blob',
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("Token")
        }
    }).then((response) => {
        // Let's create a link in the document that we'll
        // programmatically 'click'.
        const link = document.createElement('a');

        // Tell the browser to associate the response data to
        // the URL of the link we created above.
        link.href = window.URL.createObjectURL(
            new Blob([response.data], { type: response.headers['content-type'] })
        );

        // Tell the browser to download, not render, the file.
        link.setAttribute('download', fileName);

        // Place the link in the DOM.
        document.body.appendChild(link);

        // Make the magic happen!
        link.click();

        ElMessage.success('下載成功!');
    }).catch((response) => {

        ElMessage.error('下載失敗!');
    })
};



